import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

export interface SectionTabsProps {
  className?: string;
  tabs: Array<SectionTab>;
}

export interface SectionTab {
  handleClick: () => void;
  isActive: boolean;
  text: string;
  dataTestAttrs?: DataTestAttrs;
}

export default function SectionTabs(props: SectionTabsProps): JSX.Element {
  return (
    <div className={classNames('sectionTabs', props.className)}>
      <ul className="sectionTabs-nav">
        {props.tabs.map((tab, i) => (
          <li
            className={classNames('sectionTabs-navItem', {active: tab.isActive})}
            key={i}
            onClick={tab.isActive ? () => {} : tab.handleClick}
            {...getTestProps({component: 'SectionTab', element: 'navItem', ...(tab.dataTestAttrs ?? {})})}
          >
            <div className="sectionTabs-navItem-title">
              <span className="sectionTabs-navItem-title-inner">{tab.text}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

SectionTabs.propTypes = {
  className: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      handleClick: PropTypes.func.isRequired,
      isActive: PropTypes.bool.isRequired,
      text: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
};
